<template>
    <div>
        <van-popup
            class="popup"
            v-model="drawer"
            @closed="closePopup"
            position="right"
            :close-on-popstate="true"
            :close-on-click-overlay="false" 
            :style="{ height: '100%' }"
        >
            <div class="alert-model">
                <div class="search-title">
                    <div class="tle">选择商品</div>
                    <van-icon @click="closeModel" name="cross" />
                </div>
                <div class="search-model">
                    <div class="search-box">
                        <van-field v-model="inputText" label="" placeholder="搜索商品" />
                        <van-icon name="search" @click="search" />
                    </div>
                </div>
                <div class="goods-box">
                    <div class="rgt-box">
                        <van-list
                            class="scroll"
                            v-model="loading"
                            :finished="finished"
                            :immediate-check="false"
                            style="width:100%"
                            finished-text="没有更多了"
                            @load="getData"
                        >
                            <div class="good-items" v-for="(item,index) in goods" :key="index" @click="selectGood(item)">
                                <div class="good-img">
                                    <van-image fit="cover" style="width:100%;height:100%" :src="item.img" />
                                </div>
                                <div class="good-item">
                                    <div class="item-name">
                                        {{item.name}}
                                    </div>
                                    <div class="item-price">
                                        <div>{{item.code}}</div>
                                        <div>
                                            <span>{{item.goodsSpec?item.goodsSpec:'无规格'}}&nbsp;&nbsp;({{item.unit}})</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </van-list>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    name: 'QianweiApputilsFrontendIndex',
    data() {
        return {
            inputText: '',
            selectCateId:'',
            drawer: false,
            lftId: '',
            batchId: "",
            keyword: '',
            pageNum: 1,
            pageSize: 20,
            categoryId: '',
            warehouseId:'',
            merchantId:'',
            cateList:[],
            goods:[],
            loading:false,
            finished:false,
        };
    },
    mounted() {
        
    },
    methods: {
        search(){
            this.pageNum = 1
            this.goods = []
            this.getData()
        },
        selectLeft(item){
            if(item){
                this.selectCateId = item.id
                this.categoryId = item.id
            }
            this.pageNum = 1
            this.goods = []
            this.getData()
        },
        selectGood(item){
            console.log(item)
            this.$emit('close',item)
            this.drawer = false
        },
        closeModel(){
            this.drawer = false
        },
        closePopup(){
            this.$emit('close','');
        },
        getData(){
            this.$request.get('purchaseOrder/queryOutGoods',{
                keyword:this.inputText,
                pageNum:this.pageNum,
                pageSize:this.pageSize,
                orgId:this.merchantId,
            }).then(res=>{
                if(res.content.content.length == 20){
                    this.goods = this.goods.concat(res.content.content)
                    this.pageNum+=1
                    this.loading = false
                }else{
                    this.goods = this.goods.concat(res.content.content)
                    this.loading = false
                    this.finished = true
                }
            }).catch(res=>{})
        },
        open(merchantId){
            this.pageNum = 1
            this.merchantId = merchantId
            this.inputText = ''
            this.goods = []
            this.getData();
            this.drawer = true
        }
    },
};
</script>

<style scoped>
    .popup{
        background: transparent;
        overflow-y: hidden;
        width: 85%;
    }
    .alert-model{
        height:calc(100vh);
        background:#fff;
    }
    .search-title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color:#888;
        padding:10px;
        border-bottom:1px solid #ddd
    }
    .search-title .tle{
        font-size:14px;
    }
    .search-title .van-icon{
        font-size:20px;
    }
    .search-model{
        padding:10px;
    }
    .search-box{
        background:#f2f2f2;
        border-radius:50px;
        height:40px;
        padding:0 20px;
        display: flex;
        align-items: center;
    }
    .search-box .search-ipt{
        width:calc(100% - 70px)
    }
    .search-box .van-icon{
        width:20px;
        text-align: right;
        font-size:20px;
    }
    .search-box .van-cell{
        padding:0 !important;
        line-height:40px;
        font-size:14px;
        background: transparent !important;
    }
    .goods-box{
        height: 100%;
        display: flex;
    }
    .lft-box{
        width: 200px;
        height: calc(100% - 220px);
        overflow-y: auto;
    }
    .lft-list{
        padding:30px 20px;
        border-bottom:1px solid #eee;
        font-size:24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color:#555;
    }
    .lft-list-sel{
        padding:30px 20px;
        border-bottom:1px solid #eee;
        font-size:24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        background: #f2f2f2;
        color:#000;
        font-weight: 600;
    }
    .rgt-box{
        padding-left:5px;
        padding-top: 5px;
        height: calc(100% - 102px);
        width: 100%;
        overflow-y: auto;
        background: #eee;
    }
    .good-items{
        display: flex;
        background: #fff;
        padding: 10px;
        margin-bottom: 6px;
    }
    .good-items .good-img{
        width:80px;
        height:80px;
    }
    .good-items .good-item{
        width: calc(100% - 160px);
        margin-left: 10px;
    }
    .good-item .item-name{
        font-size: 14px;
        height:40px;
        max-height: 40px;
        text-align: left;
        color:#333;
        white-space: initial;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        width: 98%;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .good-item .item-price{
        color:#888;
        text-align: left;
    }
</style>


// WEBPACK FOOTER //
// src/views/supplierOrder/selectGoods.vue